<div mat-dialog-title class="cust-modal-title">
    <h2 class="m-0">{{ parentData.title }}</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content *ngIf="!editMode">
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Credit Amount</mat-label>
        <input
          [(ngModel)]="newCreditData.amount"
          matInput
          #input
        />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Reason</mat-label>
        <input
          [(ngModel)]="newCreditData.purpose"
          matInput
          #input
        />
      </mat-form-field>
    </div>
    <div>
        <mat-form-field class="w-100" appearance="outline" class="col-12" (click)="picker1.open()" style="padding: 0px;">
            <mat-label>Probable return date</mat-label>
            <input matInput [matDatepicker]="picker1" [(ngModel)]="newCreditData.aproxRepaymentDate" readonly>
            <!-- <mat-hint>MM/DD/YYYY</mat-hint> -->
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1 disabled="false"></mat-datepicker>
          </mat-form-field>
    </div>
    <div class="radio_group">
        <label>Loan Type: </label> <br>
        <mat-radio-group [(ngModel)]="newCreditData.paymentMode">
          <mat-radio-button [value]="1">Cash</mat-radio-button>
          <mat-radio-button [value]="2">Bank</mat-radio-button>
          <mat-radio-button [value]="3">Wallet</mat-radio-button>
        </mat-radio-group>
      </div>
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Description</mat-label>
        <textarea
          [(ngModel)]="newCreditData.repaymentNotes"
          matInput
        ></textarea>
      </mat-form-field>
    </div>
  </mat-dialog-content>

  <mat-dialog-content *ngIf="editMode">
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Amount</mat-label>
        <input
          [(ngModel)]="editCreditData.amount"
          matInput
          #input
        />
      </mat-form-field>
    </div>
    <div class="radio_group">
        <label>Status: </label>
        <mat-radio-group [(ngModel)]="editCreditData.status">
          <mat-radio-button [value]="1">Active</mat-radio-button>
          <mat-radio-button [value]="0">Paid Fully</mat-radio-button>
        </mat-radio-group>
      </div>
  </mat-dialog-content>
  
  <mat-dialog-actions align="end" >
    <button mat-button mat-dialog-close>Cancel</button>
    <button
      mat-flat-button
      color="accent"
      
      (click)="onPost()"
    >
      Confirm
    </button>
  </mat-dialog-actions>
  